import { useRef, useState } from 'react';

import { Autocomplete, CircularProgress, TextField } from '@mui/material';
import { LicitacaoFormaContratacao } from '../site/features/licitacao/types/Licitacao';
import useLicitacaoFormaContratacaoSiteFetch from './useLicitacaoFormaContratacaoSiteFetch';

type Props = {
  isdisabled?: boolean;
  isLoading?: boolean;
  required?: boolean;
  value?: LicitacaoFormaContratacao | null;
  handleSearchChange: (newValue: LicitacaoFormaContratacao) => void;
};

const TxtLicitacaoFormaContratacaoSite = ({
  isdisabled,
  isLoading,

  required,
  value,
  handleSearchChange
}: Props) => {
  const timeoutRef = useRef<number | null>(null);
  const loading = useRef(false);

  const handleSetLoad = (newValue: boolean) => {
    loading.current = newValue;
  };

  const [inputValue, setInputValue] = useState('');
  const { options } = useLicitacaoFormaContratacaoSiteFetch({ inputValue, handleSetLoad });

  return (
    <Autocomplete
      value={value && value.id ? value : null} //
      size="small"
      options={options}
      isOptionEqualToValue={(option, value) => option.id === value.id}
      getOptionLabel={option => {
        const licitacaoFormaContratacao = option as LicitacaoFormaContratacao;
        let descricao: string = '';
        if (!licitacaoFormaContratacao) {
          return '';
        }

        if (licitacaoFormaContratacao.nome) {
          descricao = licitacaoFormaContratacao.nome;
        }
        return descricao;
      }}
      loading={loading.current}
      onInputChange={(event, newInputValue) => {
        if (timeoutRef.current) {
          clearTimeout(timeoutRef.current);
        }
        timeoutRef.current = window.setTimeout(() => {
          setInputValue(newInputValue);
        }, 700); // 300ms delay
      }}
      onChange={(event, newValue) => {
        handleSearchChange(newValue as LicitacaoFormaContratacao);
      }}
      renderInput={params => (
        <TextField
          {...params}
          label="Forma de Contratação"
          required={required ? true : false}
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <>
                {loading.current ? <CircularProgress color="inherit" size={20} /> : null}
                {params.InputProps.endAdornment}
              </>
            )
          }}
        />
      )}
    />
  );
};
export default TxtLicitacaoFormaContratacaoSite;
